import { ScreenQuestionProps } from './types';

const BASE_SKILL_EXPERIENCE_QUESTION =
  'How many years of work experience do you have with this skill?';

export const getSkillExperienceQuestionText = (skill?: string): string => {
  const trimmed = typeof skill === 'string' ? skill.trim() : '';
  return trimmed
    ? `How many years of work experience do you have with ${trimmed}?`
    : BASE_SKILL_EXPERIENCE_QUESTION;
};

const BASE_SKILL_QUESTION: ScreenQuestionProps = {
  title: 'Skills',
  question: BASE_SKILL_EXPERIENCE_QUESTION,
  type: 'Skills',
  category: 'PreDefined',
  answerType: 'numeric',
};

export const SKILL_EXPERIENCE_PREDEFINED_QUESTION: ScreenQuestionProps = {
  ...BASE_SKILL_QUESTION,
  required: true,
};

export const createSkillExperienceQuestion = (
  overrides: Partial<ScreenQuestionProps> = {},
): ScreenQuestionProps => ({
  ...BASE_SKILL_QUESTION,
  required: false,
  jobFunction: '',
  expectedAnswer: undefined,
  ...overrides,
  question: overrides.question ?? getSkillExperienceQuestionText(overrides.jobFunction ?? ''),
});
